
import { LoaderIcon } from 'vue-feather-icons'
import { initiateZohoDesk, openWidget } from '~/fc/ZohoDesk';
export default {
    name: 'ZohoDeskWidgetLoader',
    components: { LoaderIcon },
    data: () => ({
        loadingFW: false,
        fwLoaded: false
    }),
    computed: {
        info() { return this.$store.state.info; },
        hasFiles() { return !!this.$store.state.list.length; },
        enablePreview() { return this.info.active === "PreviewTemplate" || this.info.customVariables?.enablePreview; },
        dialogIsOpen() { return this.$store.state.store.dialogIsOpen },
        previewLoaded() { return this.enablePreview && this.hasFiles }
    },
    mounted() {
        this.$bus.$on('OPEN_ZW', () => {
            if (window.ZohoDeskAsap) { openWidget() }
            else { this.loadAndOpenFW() }
        })
    },
    methods: {
        markAsLoaded() {
            this.loadingFW = false
            this.fwLoaded = true
        },
        loadAndOpenFW() {
            this.loadingFW = true

            // eslint-disable-next-line no-unused-expressions, no-var
            window.ZohoDeskAsapReady = function (s) { var e = window.ZohoDeskAsap__asyncalls = window.ZohoDeskAsap__asyncalls || []; window.ZohoDeskAsapReadyStatus ? (s && e.push(s), e.forEach(s => s && s()), window.ZohoDeskAsap__asyncalls = null) : s && e.push(s) };

            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = 'https://desk.zohocloud.ca/portal/api/web/asapApp/7942000000126664?orgId=110001563481'
            script.id = "zohodeskasapscript"
            script.defer = true
            script.async = true
            document.body.appendChild(script)

            const self = this;
            window.ZohoDeskAsapReady && window.ZohoDeskAsapReady(async function () {
                await initiateZohoDesk()
                openWidget()
                setTimeout(() => {
                    self.markAsLoaded()
                }, 200)
            });
        }
    }
}
